import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import Router from '_src/app/router'
import { Provider } from "mobx-react"
import registerServiceWorker from './registerServiceWorker'

ReactDOM.render(
  <Provider>
    <Router />
  </Provider>,
  document.getElementById('root')
)
registerServiceWorker()